'use strict';

class userService {
  constructor($http, $cacheFactory) {
    this.$http = $http;
    this.$cacheFactory = $cacheFactory;

    this.userCache = $cacheFactory('user-cache', { capacity: 5 });
  }

  get() {
    return this.$http.get('/user/', {
      cache: this.userCache
    });
  }

  getForce() {
    this.userCache.removeAll();
    return this.$http({
      method: 'GET',
      url: `/user/`,
      ignoreAuth: true,
      cache: this.userCache
    });
    // return this.$http.get('/user/', {
    //   cache: this.userCache
    // });
  }
  updateEmail(email) {
    this.userCache.removeAll();
    return this.$http({
      method: 'PUT',
      url: `/user/email`,
      data: {
        email: email
      },
      ignoreAuth: true
    });
  }

  getSettings() {
    return this.$http.get(`/user/settings/notification`);
  }

  getMultifactorAuth() {
    return this.$http.get(`/user/multifactor-auth`);
  }

  verifyMultifactorAuth(code) {
    return this.$http.post(`/user/multifactor-auth/verify/` + code);
  }

  generateMFACode() {
    return this.$http.put(`/user/multifactor-auth/generate`);
  }

  disableMFA() {
    return this.$http.put(`/user/multifactor-auth/disable`);
  }

  forgetMFADevices() {
    return this.$http.put(`/user/multifactor-auth/forget`);
  }

  saveSettings(params) {
    this.userCache.removeAll();
    return this.$http.put(`/user/settings/notification`, params);
  }

  getLinkedOriginators() {
    return this.$http.get(`/user/originators`);
  }

  registerUser(params, captcha) {
    return this.$http.post(`/user/public/register`, params, {
      headers: {
        Captcha: captcha || ''
      }
    });
  }

  updatePassword(data) {
    this.userCache.removeAll();
    return this.$http({
      method: 'PUT',
      url: `/user/password`,
      data: data,
      ignoreAuth: true
    });
  }

  login(username, password) {
    return this.$http({
      method: 'GET',
      url: `/user/login`,
      ignoreAuth: true,
      headers: {
        Authorization: 'Basic ' + btoa(username + ':' + password)
      }
    });
  }

  loginWithMFACode(username, password, mfaCode, mfaTrust) {
    return this.$http({
      method: 'GET',
      url: `/user/login`,
      ignoreAuth: true,
      headers: {
        Authorization: 'Basic ' + btoa(username + ':' + password),
        MFACode: mfaCode,
        MFATrustDevice: mfaTrust
      }
    });
  }

  logout() {
    return this.$http.get(`/user/logout`);
  }

  resendWelcomeEmail(originatorId) {
    return this.$http.post(`/internal/welcomeletter`, {}, {
      headers: {
        'Originator-Id': originatorId
      }
    });
  }

  // REGISTRATION
  register(data, captcha) {
    return this.$http.post(`/signup/`, {
      registerData: data
    }, {
      headers: {
        Captcha: captcha || ''
      }
    });
  }

  // PASSWORD
  validatePasswordLink(id, dt, key) {
    return this.$http.post(`/signup/password/validate`, {
      linkData: {
        id: id,
        dt: dt,
        key: key
      }
    });
  }

  remindPassword(email) {
    return this.$http.post(`/signup/password/forgot`, {
      data: {
        email: email
      }
    });
  }

  resetPassword(id, dt, key, password) {
    return this.$http.post(`/signup/password/change`, {
      linkData: {
        id: id,
        dt: dt,
        key: key,
        password: password
      }
    });
  }
}

userService.$inject = ['$http', '$cacheFactory'];

angular
  .module('SendRegning')
  .service('userService', userService);
